import { getClientSideCookieValue } from './GetClientSideCookieValue';

export const getClientUserId = (): string => {
  const userId = getClientSideCookieValue<string>('_sp_id.1fff');
  return userId?.split('.')?.[0] || '';
};
